<template>
    <section id="mainContainer">
        <userHeader ref="userHeader"></userHeader>
        <section class="mid-container">
            <div class="blog-page">
                <section class="blog-top-section"
                    :style="{ 'background-image': `url(${require('@/assets/images/blog-banner-img.jpg')})` }">
                    <div class="container">
                        <h1>Blog</h1>
                        <div class="blog-list-slider" v-if="allBlogs.length > 0">
                            <div class="blog-items" v-for="slider in allBlogs" :key="slider.id">
                                <div class="blog-items--inner">
                                    <div class="blog-items--img">
                                        <img :src="getCdnImageAddress(slider.blogImage, `w_259,h_190/`)" width="100%" />
                                    </div>
                                    <div class="blog-items--content">
                                      
                                        <h2>
                                            <router-link :to="`/blogs/${slider.slug}`" @click="closeMenu()">{{ slider.title }}</router-link>
                                            <!-- <a href="blog-details.html">{{ slider.title }}</a> -->
                                         </h2>
                                         <div class="blog-tag-name">
                                            {{ slider.blogCategory }}
                                        </div>
                                        <div class="blog-items--dec">
                                            {{ useStripHtml(getBlogDescription(slider)) }} 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="blog-search-section">
                    <div class="container">
                        <div class="custom-row">
                            <div class="blog-search">
                                <input type="text" placeholder="Enter your keywords…" v-model="searchedText"
                                    @keyup.enter="fetchBlogs(), fetchBlogsCount()" />
                                <button class="submit-icon"></button>
                            </div>
                            <div class="blog-select">
                                <select class="selectbox" id="blogCategorySelectBox" v-model="searchedBlogCategory"
                                    @change="fetchBlogs(), fetchBlogsCount()">
                                    <option value="">Select the blog category</option>
                                    <option v-for="category in blogCategories" :key="category.id"
                                        :value="category.title">
                                        {{ category.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="blog-list-section">
                    <div class="container">
                        <h5>Displaying Posts ({{ blogsCount }})</h5>
                        <div class="blog-list--inner">
                            <div class="blog-list-box" v-for="(blog, index) in blogs" :key="blog.id">
                                <div class="blog-box--inner">
                                    <div class="blog-list--img">
                                        <img :src="getCdnImageAddress(blog.blogImage, `w_95,h_95/`) " alt="" />
                                    </div>
                                    <div class="blog-list--content">
                                        
                                        <h4>
                                            <router-link :to="`/blogs/${blog.slug}`" @click="closeMenu()">{{ blog.title }}</router-link>
                                            <!-- <a href="blog-details.html">{{ blog.title }}</a> -->
                                        </h4>
                                        <div class="blog-tag-name">
                                            {{ blog.blogCategory }}
                                        </div>
                                        <div class="blog-des">
                                           <p>{{ useStripHtml(getBlogDescription(blog)) }} </p> 
                                        </div>

                                        <div class="blog-time-author">
                                            <div class="blog-time">{{ blog.relativePostDate }}</div>
                                            <div class="blog-author">by {{ blog.author }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pagination-box" v-if="totalPages > 1">
                            <ul>
                                <li v-if="currentPage !== 1" @click="changePage(currentPage - 1)"
                                    class="pagination-first">
                                    <button></button>
                                </li>
                                <li v-for="page in visiblePages" :key="page" @click="changePage(page)"
                                    v-if="totalPages != 1">
                                    <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
                                </li>
                                <li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)"
                                    class="pagination-last">
                                    <button></button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <userFooter></userFooter>
        <ChatbotPopup></ChatbotPopup>
    </section>
</template>
<script lang="ts">
import { defineComponent , ref } from 'vue';
import userHeader from "@/components/userHeader.vue";
import userFooter from "@/components/userFooter.vue";
import axios from 'axios';
import moment from 'moment';
import 'slick-carousel';
import $ from 'jquery';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import ChatbotPopup from '@/components/chatbotPopup.vue';

interface Blogs {
    id: number;
    title: string;
    description: string;
    author: string;
    blogCategory: string;
    location: string;
    blogImage: string;
    status: number;
    blogPostDate: string
    editing?: boolean;
    Created_at?: string;
    Updated_at?: string;
    relativePostDate?: string;
    slug: string;
}

export default defineComponent({
    name: "blogs",
    components: {
        userHeader,
        userFooter,
        ChatbotPopup
    },
    data() {
        return {
            blogs: [] as Blogs[],
            blogsCount: 0,
            blogCategories: [] as any,
            totalPages: 0,
            currentPage: 1,
            limit: 10,
            searchedText: '',
            searchedBlogCategory: '',
            allBlogs:[] as Blogs[]
        };
    },
    created() {
        this.fetchBlogs();
        this.fetchBlogsCount();
        this.blogCategory();
        this.fetchAllBlogs()
    },
    computed: {
        visiblePages() {
            const maxVisiblePages = 5;
            const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
            let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
            let end = start + maxVisiblePages - 1;
            if (end > this.totalPages) {
                end = this.totalPages;
                start = Math.max(end - maxVisiblePages + 1, 1);
            }
            return Array.from({ length: end - start + 1 }, (_, i) => start + i);
        },
    },
    watch: {
        allBlogs: {
            handler(newVal) {
                if (newVal.length > 0) {
                    this.$nextTick(() => {
                        this.initializeBlogSlider();
                    });
                }
            },
            deep: true
        },
    },

    methods: {
        async fetchBlogs(limit = 10, skip = 0) {
            const params = new URLSearchParams();
            params.append('status', '1');
            if (this.searchedText) {
                params.append('searchedText', this.searchedText)
                params.append('limit', this.limit.toString())
                params.append('skip', skip.toString());
                if (this.searchedBlogCategory) {
                    params.append('blogCategory', this.searchedBlogCategory)
                }
            } else {
                if(!this.searchedBlogCategory){
                params.append('limit', limit.toString());
                const skipArtice = (this.currentPage - 1) * this.limit;
                params.append('skip', skipArtice.toString());
            }else{
                    params.append('blogCategory', this.searchedBlogCategory)
                    params.append('limit', this.limit.toString())
                    params.append('skip', skip.toString());
                }
            }
            try {
                const response = await axios.get(`${API_BASE_URL}/blog/?${params.toString()}`);
                this.blogs = response.data.map((blog: { blogPostDate: moment.MomentInput; }) => {
                    return {
                        ...blog,
                        relativePostDate: moment(blog.blogPostDate).fromNow() // Changed from created_at to blogpost date 
                    };
                });
            } catch (error) {
                console.error('Error fetching blogs:', error);
            }
        },
        initializeBlogSlider() {
            if ($('.blog-list-slider').length) {
                $('.blog-list-slider').slick({
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    responsive: [
                        {
                            breakpoint: 567,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                                arrows: false
                            }
                        }
                    ]
                });
            }
        },
        async fetchAllBlogs(){
            try {
                const response = await axios.get(`${API_BASE_URL}/blog/?status=1`)
                this.allBlogs=response.data
            } catch (error) {
                console.error(Error)
                
            }
        },

        async fetchBlogsCount() {
            const params = new URLSearchParams();
            if (this.searchedText) {
                params.append('searchedText', this.searchedText)
            }
            if (this.searchedBlogCategory) {
                params.append('blogCategory', this.searchedBlogCategory)
            }
            params.append('status', '1');
            try {
                const response = await axios.get(`${API_BASE_URL}/blog/count/?${params.toString()}`)
                this.blogsCount = response.data.count
                this.totalPages = Math.ceil(this.blogsCount / 10);
            } catch (error) {
                console.error(Error)
            }
        },
        getBlogDescription(blog: Blogs): string {
            const fullDescription = blog.description;
            if (fullDescription.length > 115) {
                return `${fullDescription.slice(0, 115)}...`;
            } else {
                return fullDescription
            }
        },
        async blogCategory() {
            try {
                const response = await axios.get(`${API_BASE_URL}/blogcategory/?status=1`);
                this.blogCategories = response.data;
            } catch (error) {
                console.error('Error fetching blog categories:', error);
            }
        },
        changePage(page: number) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
                this.fetchBlogs(this.limit, (this.currentPage - 1) * this.limit);
            }
        },
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        },
        useStripHtml(html : string) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
         closeMenu(){
            (this.$refs.userHeader as any).closeMenu();

        }
    },
});
</script>